module.exports = __webpack_public_path__ + "img/3.bb0b8135.png";